exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".headStyle {\n  text-align: center;\n  font-size: 20px; }\n\n/deep/ .mat-menu-panel.test {\n  margin-top: 25px;\n  background-color: #b7b7b7;\n  width: 160px;\n  text-align: left;\n  color: #fff; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/vtrackOneqlik/oneqlik_wetrack/src/app/report/report component/ac-report/ac-report.component.scss
// module id = ../../../../../src/app/report/report component/ac-report/ac-report.component.scss
// module chunks = main